import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-solid-svg-icons';

import classNames from 'classnames';

export default class PaginationButtons extends React.Component {
  static propTypes = {
    allIds: PropTypes.array,
    currentIndex: PropTypes.number.isRequired,
    entityId: PropTypes.number.isRequired,
    nextIndex: PropTypes.number,
    prevIndex: PropTypes.number,
    onClick: PropTypes.func.isRequired
  };

  handleClick = (e, index) => {
    const { allIds, onClick } = this.props;
    if (index != null && index >= 0 && index < allIds.length) {
      onClick(e, index);
    }
  }

  render() {
    const { currentIndex, entityId, allIds, nextIndex, prevIndex } = this.props;

    if (allIds.length === 0 || allIds[currentIndex] !==  entityId ||
        (nextIndex === null && prevIndex === null)) {
      return null;
    }

    const prevBtnClass =  classNames("btn btn-gray btn-sm prev-btn", {
      "disabled": prevIndex === null
    });

    const nextBtnClass =  classNames("btn btn-gray btn-sm next-btn", {
      "disabled": nextIndex === null || nextIndex >= allIds.length
    });

    return (
      <div className="pull-right button-group">
        <div className={prevBtnClass} name="prev" onClick={e => this.handleClick(e, prevIndex)}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <div className={nextBtnClass} name="next" onClick={e => this.handleClick(e, nextIndex)}>
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
    );
  }
}
